import _objectWithoutProperties from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["input"];
import KivaProxy from '@/utils/kivaProxy/src';
export default {
  name: 'KvStateSelect',
  props: {
    value: String,
    country: String
  },
  data: function data() {
    return {
      mutableValue: this.value,
      loading: false,
      states: []
    };
  },
  methods: {
    input: function input() {
      this.$emit('input', this.mutableValue);
    }
  },
  computed: {
    attrs: function attrs() {
      return this.$attrs;
    },
    listeners: function listeners() {
      var _this$$listeners = this.$listeners,
        input = _this$$listeners.input,
        listeners = _objectWithoutProperties(_this$$listeners, _excluded);
      return listeners;
    },
    isDisabled: function isDisabled() {
      return this.country !== 230;
    }
  },
  watch: {
    value: function value(val) {
      this.mutableValue = val;
    },
    country: {
      immediate: true,
      handler: function handler(val) {
        this.input();
        if (val) {} else {
          this.mutableValue = null;
        }
      }
    },
    mutableValue: function mutableValue() {
      this.input();
    }
  }
};